// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_speakerInputs__MgfC4 {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-end;
}
.styles_speakerInputs__MgfC4 .styles_speakerWrapper__B58HH {
  width: 100%;
  position: relative;
}
.styles_speakerInputs__MgfC4 .styles_speakerWrapper__B58HH .styles_removeIcon__GllHz {
  position: absolute;
  right: -8px;
  top: -8px;
}
.styles_speakerInputs__MgfC4 .styles_speakerWrapper__B58HH input {
  width: calc(100% - 30px);
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 0.5rem;
  font-size: 14px;
  transition: border 0.3s;
}
.styles_speakerInputs__MgfC4 .styles_speakerWrapper__B58HH input::placeholder {
  color: rgba(0, 0, 0, 0.8);
}
.styles_speakerInputs__MgfC4 .styles_speakerWrapper__B58HH input:focus {
  border-color: #6ba7a8;
  outline: none;
}
.styles_speakerInputs__MgfC4 .styles_bulkImportContainer__pMyc3 {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.styles_speakerInputs__MgfC4 .styles_bulkImportContainer__pMyc3 textarea {
  resize: none;
  display: flex;
  border: 1px dashed #ddd;
  border-radius: 0.5rem;
  font-size: 14px;
  transition: border 0.3s;
  padding: 10px 15px;
  color: #666;
}
.styles_speakerInputs__MgfC4 .styles_bulkImportContainer__pMyc3 textarea:focus {
  border-color: #6ba7a8;
  outline: none;
}
.styles_speakerInputs__MgfC4 .styles_importContainer__fsjoK {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
}
.styles_speakerInputs__MgfC4 button span {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  padding: 12px 16px;
}
.styles_speakerInputs__MgfC4 button div {
  border: #6ba7a8 1px solid;
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 12px;
  border-radius: 4rem;
}
.styles_speakerInputs__MgfC4 button:hover {
  opacity: 0.8;
}
.styles_speakerInputs__MgfC4 button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/TranscriptUploader/SpeakerField/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,qBAAA;AACF;AACE;EACE,WAAA;EACA,kBAAA;AACJ;AACI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AACN;AAEI;EACE,wBAAA;EACA,kBAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;AAAN;AAEM;EACE,yBAAA;AAAR;AAGM;EACE,qBAAA;EACA,aAAA;AADR;AAKE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAHJ;AAII;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AAFN;AAGM;EACE,qBAAA;EACA,aAAA;AADR;AAKE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAHJ;AAMI;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAJN;AAMI;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;AAJN;AAOI;EACE,YAAA;AALN;AAQI;EACE,sBAAA;EACA,mBAAA;AANN","sourcesContent":[".speakerInputs {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  align-items: flex-end;\n\n  .speakerWrapper {\n    width: 100%;\n    position: relative;\n\n    .removeIcon {\n      position: absolute;\n      right: -8px;\n      top: -8px;\n    }\n\n    input {\n      width: calc(100% - 30px);\n      padding: 10px 15px;\n      border: 1px solid #ddd;\n      border-radius: 0.5rem;\n      font-size: 14px;\n      transition: border 0.3s;\n\n      &::placeholder {\n        color: rgba(0, 0, 0, 0.8);\n      }\n\n      &:focus {\n        border-color: #6ba7a8;\n        outline: none;\n      }\n    }\n  }\n  .bulkImportContainer {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    textarea {\n      resize: none;\n      display: flex;\n      border: 1px dashed #ddd;\n      border-radius: 0.5rem;\n      font-size: 14px;\n      transition: border 0.3s;\n      padding: 10px 15px;\n      color: #666;\n      &:focus {\n        border-color: #6ba7a8;\n        outline: none;\n      }\n    }\n  }\n  .importContainer {\n    display: flex;\n    flex-direction: row;\n    gap: 1rem;\n    align-items: center;\n  }\n  button {\n    span {\n      font-size: 14px;\n      font-weight: 600;\n      color: #fff;\n      padding: 12px 16px;\n    }\n    div {\n      border: #6ba7a8 1px solid;\n      display: flex;\n      align-items: center;\n      background-color: #fff;\n      padding: 12px;\n      border-radius: 4rem;\n    }\n\n    &:hover {\n      opacity: 0.8;\n    }\n\n    &:disabled {\n      background-color: #ccc;\n      cursor: not-allowed;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"speakerInputs": `styles_speakerInputs__MgfC4`,
	"speakerWrapper": `styles_speakerWrapper__B58HH`,
	"removeIcon": `styles_removeIcon__GllHz`,
	"bulkImportContainer": `styles_bulkImportContainer__pMyc3`,
	"importContainer": `styles_importContainer__fsjoK`
};
export default ___CSS_LOADER_EXPORT___;
